export const USER_ROLE_PATIENT = { min: 1, max: 10 };
export const USER_ROLE_PROVIDER = { min: 21, max: 30 };
export const USER_ROLE_ORGANIZATION = { min: 41, max: 50 };
export const USER_ROLE_SUPER_ADMINISTRATOR = { min: 91, max: 100 };
export function isRoleInRange(roleId, range) {
    const numeric = typeof roleId === 'number' ? roleId : typeof roleId === 'string' ? Number(roleId) : NaN;
    return Number.isFinite(numeric) && numeric >= range.min && numeric <= range.max;
}
export function isPatientRole(roleId) {
    return isRoleInRange(roleId, USER_ROLE_PATIENT);
}
export function isProviderRole(roleId) {
    return isRoleInRange(roleId, USER_ROLE_PROVIDER);
}
export function isOrganizationRole(roleId) {
    return isRoleInRange(roleId, USER_ROLE_ORGANIZATION);
}
export function isSuperAdministratorRole(roleId) {
    return isRoleInRange(roleId, USER_ROLE_SUPER_ADMINISTRATOR);
}
